import { getWrapper } from './axios'
import { formDataToRequestParams } from './helpers'

export type GetGiftsCatalog = {
    limit: number
    p: number
}

export type Gift = {
    id?: number
    gift_id: string
    gift_name: string
    points: string
    thumbnail: string
    image: string
}

export type GiftsCatalogPayload = {
    status: string
    list: Gift[]
    total_count: string
}

export type SendGift = {
    id?: number
    gift_id: number
    recipient: string
    comment: string
    anon: number
    save: number
    image_data: string
}

export type SendGiftPayload = {
    status: string
    result: string
    id?: number
}

export const getGiftCatalog = (params: GetGiftsCatalog): Promise<GiftsCatalogPayload> => {
    return getWrapper('/gift/catalog', { params }) as Promise<GiftsCatalogPayload>
}

export const giftSave = (params: SendGift): Promise<SendGiftPayload> => {
    return getWrapper('/gift/save/', formDataToRequestParams<SendGift>(params), true) as Promise<SendGiftPayload>
}

export const giftDelete = (params: { id: number }): Promise<{ status: string }> => {
    return getWrapper('/gift/delete/', formDataToRequestParams(params), true) as Promise<{ status: string }>
}

export const giftRead = (params: { id: number }): Promise<{ status: string }> => {
    return getWrapper('/gift/read/', formDataToRequestParams(params), true) as Promise<{ status: string }>
}

export const giftHide = (params: { id: string | number }): Promise<{ status: string }> => {
    return getWrapper('/gift/hide/', formDataToRequestParams(params), true) as Promise<{ status: string }>
}
